import BaseButton from '@/components/BaseButton'
import goTopButton from '@/components/GoTopButton'
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { DeactivateReasonEnum } from '@/enums/deactivate-reason.enum'
import { BlockReasonEnum } from '@/enums/block-reason.enum'
import { showProductDetails, showAccountDetails, showOrderDetails, showBeneficiaryDetails } from '@/tools/utils.js'
import { Modal } from 'bootstrap';

export default {

  components: {
    BaseButton,
    goTopButton
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      card: null,
      cardDetail: null,
      responseErr: null,
      isProcessing: false,
      voucherAmountValue: null,
      voucherBeginDate: null,
      voucherEndDate: null,
      deactivateReason: null,
      deactivateReasonEnum: DeactivateReasonEnum,
      blockingReason: null,
      blockReasonEnum: BlockReasonEnum,
      pan: {
        unmaskedPan: null,
        panImg: null,
        isPanProcessing: false,
        panResponseErr: null
      }
    }
  },
  created () {
    if (this.$store.state.cards.card) {
      this.card = this.$store.state.cards.card.card
    }
    if (!this.card) {
      this.$store.dispatch('cards/invalidData', 'CARD_EMPTY')
      this.$router.push({ name: 'card-list' })
    }
    else {
      this.$store.dispatch('cards/resetInvalidData')
      this.getDetail()
    }
  },
  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },
    async getDetail () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('cards/resetDetail')
      await this.$store.dispatch('cards/getDetail', {
        distributorRef: this.card.distributorRef,
        issuerId: this.getIssuerId(this.card.distributorRef),
        cardId: this.card.cardId,
        beneficiaryServiceRef: this.card.beneficiaryServiceRef
      }).then(
        response => {
          this.isProcessing = false
          this.responseErr = response.errorCode
        },
        error => {
          this.isProcessing = false
          this.responseErr = error.data.errorCode
        }
      )
    },
    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },
    async unmaskPan () {
      this.pan.isPanProcessing = true
      await this.$store.dispatch('cards/unmaskPan', {
        distributorRef: this.card.distributorRef,
        cardId: this.card.cardId
      }).then(
        response => {
          this.pan.isPanProcessing = false
          this.pan.panImg = response
        },
        error => {
          this.pan.isPanProcessing = false
          this.pan.panResponseErr = error.data.errorCode
        }
      )
    },
    async activate () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('cards/activate', {
        distributorRef: this.card.distributorRef,
        issuerId: this.getIssuerId(this.card.distributorRef),
        cardId: this.card.cardId,
        beneficiaryServiceRef: this.card.beneficiaryServiceRef,
        voucherBeginDate: this.voucherBeginDate,
        voucherEndDate: this.voucherEndDate,
        voucherAmountValue: this.voucherAmountValue
      }).then(
        response => {
          this.isProcessing = false
          this.responseErr = response.errorCode
          this.getDetail()
          this.showSuccess('Carte activée avec succès !')
        },
        error => {
          this.isProcessing = false
          // this.responseErr = error.data.errorCode
          this.showError(error.data.errorCode || 'BAD_REQUEST')
        }
      )
    },
    async deactivate () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('cards/deactivate', {
        distributorRef: this.card.distributorRef,
        issuerId: this.getIssuerId(this.card.distributorRef),
        cardId: this.card.cardId,
        beneficiaryServiceRef: this.card.beneficiaryServiceRef,
        deactivateReason: this.deactivateReason
      }).then(
        response => {
          this.isProcessing = false
          this.responseErr = response.errorCode
          this.getDetail()
          this.showSuccess('Carte désactivée avec succès !')
        },
        error => {
          this.isProcessing = false
          // this.responseErr = error.data.errorCode
          this.showError(error.data.errorCode || 'BAD_REQUEST')
        }
      )
    },
    async block () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('cards/block', {
        distributorRef: this.card.distributorRef,
        issuerId: this.getIssuerId(this.card.distributorRef),
        cardId: this.card.cardId,
        beneficiaryServiceRef: this.card.beneficiaryServiceRef,
        blockingReasonCode: this.blockingReason
      }).then(
        response => {
          this.isProcessing = false
          this.responseErr = response.errorCode
          this.getDetail()
          this.showSuccess('Carte bloquée avec succès !')
        },
        error => {
          this.isProcessing = false
          // this.responseErr = error.data.errorCode
          this.showError(error.data.errorCode || 'BAD_REQUEST')
        }
      )
    },

    async unblock () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('cards/unblock', {
        distributorRef: this.card.distributorRef,
        issuerId: this.getIssuerId(this.card.distributorRef),
        cardId: this.card.cardId,
        beneficiaryServiceRef: this.card.beneficiaryServiceRef
      }).then(
        response => {
          this.isProcessing = false
          this.responseErr = response.errorCode
          this.getDetail()
          this.showSuccess('Carte débloquée avec succès !')
        },
        error => {
          this.isProcessing = false
          // this.responseErr = error.data.errorCode
          this.showError(error.data.errorCode || 'BAD_REQUEST')
        }
      )
    },

    showProduct (productExternalReference) {
      this.$store.dispatch('products/setProduct',{
        prb1: productExternalReference,
        prb7: this.card.distributorRef
      })
      return showProductDetails()
    },

    showAccount (accountDetailsPageContext) {
      this.$store.dispatch('accounts/setAccount', {
        accountHierarchyNumber: accountDetailsPageContext[0],
        distributorRef: this.card.distributorRef,
        beneficiaryServiceRef: accountDetailsPageContext[2],
        issuerId: accountDetailsPageContext[1],
        singleFunderAccount: this.$store.state.cards.cardDetail.singleFunderAccount
      })
      return showAccountDetails()
    },

    showCard (card) {
      this.$store.dispatch('cards/setCard', { card: card })
      this.card = card
      this.getDetail()
    },

    showOrder (order) {
      this.$store.dispatch('orders/setOrder', order)
      return showOrderDetails()
    },

    showBeneficiary (beneficiary) {
      this.$store.dispatch('beneficiaries/setBeneficiaryService', {
        beneficiaryServiceRef: beneficiary[0],
        distributorRef: beneficiary[1],
        funderContractRef: beneficiary[2],
        issuerId: this.getIssuerId(this.card.distributorRef),
        singleFunderAccount: this.$store.state.cards.cardDetail.singleFunderAccount
      })
      return showBeneficiaryDetails()
    },

    showError (msg) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.'.concat(msg))
    },
    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },
    formatDate (value) {
      if (value === null || value === '') {
        return value
      }
      return dayjs(value).format('YYYY/MM/DD HH:mm:ss')
    },
    formatTimestamp  (value) {
      if (value === null || value === '') {
        return value
      }
      return dayjs.unix(value).format('YYYY/MM/DD HH:mm:ss')
    },
    formatCurrency (amountInCents) {
      if (amountInCents === null || amountInCents === '') {
        return amountInCents
      }
      return new Intl.NumberFormat('fr-FR').format(amountInCents / 100)
    }
  }
}
